import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  > div {
    width: 250px;
    > div + div {
      > div {
        height: calc(100% - 112px) !important;
        @media screen and (max-width: 900px) {
          width: calc(100% - 168px);
          height: calc(100% - 181px) !important;
          margin-top: 10px;
          z-index: 1;
        }
        @media screen and (max-width: 561px) {
          width: calc(100% - 32px);
          height: calc(100% - 221px) !important;
        }
      }
    }
  }
  > div + div {
    margin-left: 39px;
    width: calc(100% - 289px);
  }
  @media screen and (max-width: 900px) {
    display: block;
    > div {
      width: 100% !important;
      margin-left: 0 !important;
    }
    > div + div {
      margin-top: 20px;
    }
  }
`

export const Buttons = styled.div`
  margin-top: 40px;
  text-align: right;
  button {
    margin: 0;
    border-radius: 8px;
    height: 40px;
    padding: 0 12px;
  }
`
